module.exports = __webpack_public_path__ + "img/popup-bg-invited.d3109ff.png";